import { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, FormField, Loader, Text } from 'wix-style-react';
import { Copy } from 'src/modules/events/components/copy';
import { API_URL } from 'src/utils/transport';

export const ZapierModal = () => {
  const [secretKey, setSecretKey] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/v1/dashboard/api-keys`, {
          withCredentials: true,
        });
        setSecretKey(response.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    void fetchData();
  }, []);

  return (
    <Box direction="vertical" gap={4}>
      <Text>
        To connect Ticket Spot with your Zapier account, simply grab your Zapier API key from the
        text box below. When setting up a{' '}
        <a
          href="https://zapier.com/apps/ticket-spot/integrations"
          target="_blank"
          rel="noopener noreferrer"
        >
          Ticket Spot Zap
        </a>{' '}
        for the first time, just paste the secret key into the designated field. It&apos;s that
        easy!
      </Text>
      <FormField label="Zapier API Key:">
        {loading ? <Loader size="tiny" /> : <Copy text={secretKey} isTextArea={false} />}
      </FormField>
    </Box>
  );
};
